$(window).on("load", () => {
  AOS.init({
    offset: jQuery(window).height() * 0.1,
  });
  const header = document.querySelector("header");
  const html = document.querySelector("html");

  window.addEventListener("scroll", function (e) {
    let scrollPosition = window.scrollY;
    if (+scrollPosition > 40) {
      if (!header.classList.contains("scrolled")) {
        header.classList.add("scrolled");
      }
    } else {
      header.classList.remove("scrolled");
    }
  });

  const burger = document.querySelector(".header__burger");
  const nav = document.querySelector(".header__nav");
  if (burger) {
    burger.addEventListener("click", function (e) {
      e.preventDefault();
      html.classList.toggle("nav-active");
      burger.classList.toggle("active");
      nav.classList.toggle("active");
    });
  }

  let image = document.querySelector(".homeFullImg img");
  if (image) {
    new simpleParallax(image);
  }
});
